export function togglePassword(inputType) {
  return inputType === 'password' ? 'text' : 'password';
}

export function togglePasswordConfirm(inputType) {
  return inputType === 'password' ? 'text' : 'password';
}

export function isFormValid(validation) {
  return (
    validation.form &&
    (!validation.form.email || validation.form.email.required) &&
    (!validation.form.verificationCode || validation.form.verificationCode.required) &&
    (!validation.form.password || validation.form.password.required) &&
    (!validation.form.passwordConfirm || validation.form.passwordConfirm.required) &&
    (!validation.form.oldPassword || validation.form.oldPassword.required) &&
    (!validation.form.newPassword || validation.form.newPassword.required) &&
    (!validation.form.newPasswordConfirm || validation.form.newPasswordConfirm.required)
  );
}

export function generateNonce(length = 32) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length))
  }
  return result
}
